<template>
  <div class="pre-save-pay">
    <template v-if="canSelectPayType">
      <template v-if="!guaranteePreSave.subAccountNo">
        <img
          :src="
            require('@/assets/images/supplier/guarantee-pre-save/network-notice-banner.png')
          "
          alt=""
          @click="toGuaranteePreSave"
        />
        <div class="service-desc">
          <div class="desc-title">灵活宝-保证金预存说明：</div>
          <ol>
            <li v-for="item in serviceDescList" :key="item">{{ item }}</li>
          </ol>
        </div>
      </template>
      <el-button type="primary" @click="onPreSavePay">立即缴纳</el-button>
    </template>

    <!-- 服务开通引导弹窗 -->
    <el-dialog
      class="dialog"
      :visible.sync="preSaveGuideVisible"
      title="灵活宝"
      :close-on-click-modal="false"
      width="300px"
    >
      <div class="guide-body">
        <div class="guide-title">
          <img
            src="../../../assets/images/supplier/guarantee-pre-save/title-icon.png"
            alt=""
          />
          <span class="title-main">灵活宝</span>
          <span class="title-second">保证金预存</span>
        </div>
        <div class="guide-desc">
          <span>员工</span>
          <span class="desc-important">共享保证金额度</span>
          <span>一次预存</span>
          <span>循环使用</span>
        </div>
      </div>
      <template v-slot:footer>
        <el-button type="primary" @click="toGuaranteePreSave">
          前往开通
        </el-button>
      </template>
    </el-dialog>

    <!-- 保证金预存缴纳弹窗 -->
    <el-dialog
      title="灵活宝"
      :visible.sync="preSavePayVisible"
      :close-on-click-modal="false"
      width="350px"
      class="dialog"
    >
      <div class="service-use-body">
        <div class="title-icon">
          <img
            src="../../../assets/images/supplier/guarantee-pre-save/title-icon.png"
            alt=""
          />
          <span>灵活宝</span>
        </div>
        <div class="body-desc">
          <div class="desc">
            <span class="desc-label">可用额度</span>
            <span class="desc-value">
              {{ guaranteePreSave.remainTotalAmount }}元
            </span>
          </div>
          <div class="desc">
            <span class="desc-label">本次占用额度</span>
            <span class="desc-value">
              <span class="text-danger">{{ guaranteeFee }}</span>
              元
            </span>
            <div class="desc-tip">项目结束后自动解除本次占用额度</div>
          </div>
          <div class="desc">
            <span class="desc-label">占用后额度</span>
            <span class="desc-value">
              <span class="text-danger">{{ balance }}</span>
              元
            </span>
          </div>
        </div>
      </div>
      <template v-slot:footer>
        <el-button @click="preSavePayVisible = false">取消</el-button>
        <el-button type="primary" @click="onConfirmPay">确定使用</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import useGuaranteePreSave from '@/components/guarantee/guarantee-pre-save/useGuaranteePreSave'
import { mapState } from 'vuex'
import { useGuaranteePreSaveInOrderApi } from '@/api/guarantee-pre-save'
import { depositStatusDict } from '@/dictionary/project/common'

export default {
  name: 'GuaranteePreSavePay',

  props: {
    guaranteeInfo: {
      type: Object,
      default: () => {}
    },

    orderId: {
      type: [String, Number],
      default: ''
    },

    tradeId: {
      type: [String, Number],
      default: ''
    }
  },

  data() {
    return {
      // 服务说明
      serviceDescList: useGuaranteePreSave().getServiceDescList(),

      // 保证金预存服务开通引导弹窗
      preSaveGuideVisible: false,
      // 保证金预存缴纳弹窗
      preSavePayVisible: false
    }
  },

  computed: {
    ...mapState('finance', ['guaranteePreSave']),

    guaranteeFee() {
      return this.guaranteeInfo.guaranteeFee || '0.00'
    },

    balance() {
      if (!Number(this.guaranteePreSave.remainTotalAmount)) {
        return 0
      }
      return (
        (Number(this.guaranteePreSave.remainTotalAmount) * 10000 -
          Number(this.guaranteeInfo.guaranteeFee) * 10000) /
        10000
      )
    },

    payStatus() {
      return this.guaranteeInfo.payStatus
    },

    // 是否能选择保证金缴纳方式
    canSelectPayType() {
      return this.payStatus <= depositStatusDict.PENDING.value
    }
  },

  created() {
    this.getPreSaveInfo()
  },

  methods: {
    getPreSaveInfo() {
      this.$store.dispatch('finance/getGuaranteePreSave').then(() => {
        this.$emit('getPreSaveInfo', this.guaranteePreSave)
      })
    },

    toGuaranteePreSave() {
      const route = this.$router.resolve({
        name: 'GuaranteePreSaveOpen'
      })
      window.open(route.href, '_blank')
    },

    onPreSavePay() {
      if (this.guaranteePreSave.subAccountNo) {
        if (this.balance >= 0) {
          this.preSavePayVisible = true
        } else {
          // 额度不足
          this.$message.warning('灵活保可用额度不够，请先预存。')
        }
      } else {
        // 如果没有预存账户，则标识没开通保证金预存，弹窗引导开通
        this.preSaveGuideVisible = true
      }
    },

    onConfirmPay() {
      const postData = {
        lhbAccount: this.guaranteePreSave.subAccountNo,
        totalQuota: this.guaranteePreSave.useTotalAmount,
        remainQuota: this.guaranteePreSave.remainTotalAmount
      }
      useGuaranteePreSaveInOrderApi(this.orderId, this.tradeId, postData)
        .then(() => {
          this.$message.success('灵活宝缴纳成功')
          this.$emit('paid')
          this.preSavePayVisible = false
        })
        .catch(err => {
          if (err?.message) this.$message.error(err.message)
        })
    }
  }
}
</script>

<style scoped lang="scss">
img {
  height: 66px;
}

.service-desc {
  border: 1px solid $info-second-color;
  background: $info-sixth-color;
  border-radius: 4px;
  padding: 8px;
  margin: 8px 0;

  .desc-title {
    color: $second-text-color;
    margin-bottom: 8px;
  }

  ol {
    padding: 0 0 0 16px;
    margin: 0;

    li {
      color: $third-text-color;
      line-height: 1.5;
    }
  }
}

.guide-body {
  display: flex;
  flex-direction: column;
  align-items: center;

  .guide-title {
    display: flex;
    align-items: center;

    img {
      height: 42px;
    }

    .title-main {
      font-size: 24px;
      margin: 0 8px;
      color: $text-color;
      @include text-bold;
    }

    .title-second {
      font-size: 16px;
      color: $text-color;
    }
  }

  .guide-desc {
    color: $second-text-color;
    margin-top: 18px;

    .desc-important {
      color: #e89529;
    }
  }
}

.service-use-body {
  display: flex;
  align-items: center;

  .title-icon {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 30px;

    img {
      height: 42px;
    }

    span {
      margin-top: 8px;
      font-size: 18px;
      color: $text-color;
      @include text-bold;
    }
  }

  .body-desc {
    :not(:last-child) {
      margin-bottom: 16px;
    }

    .desc {
      .desc-label {
        color: $second-text-color;

        &::after {
          content: '：';
        }
      }

      .desc-value {
        color: $text-color;
      }

      .desc-tip {
        color: $third-text-color;
        margin-top: 4px;
      }
    }
  }
}
</style>
